module.exports = __webpack_public_path__ + "static/media/python.fbef321e.svg";